export default "__VITE_ASSET__BmFf1DZA__"